import { FC } from 'react';

import styles from './VerticalServiceFlow.module.scss';
import VerticalServiceFlowStep from './VerticalServiceFlowStep';

interface Props {
  sectionTitle: string;
  verticalServiceFlowSteps: Array<{ description: string; imageUrl: string; title: string }>;
}

const VerticalServiceFlow: FC<Props> = ({ sectionTitle, verticalServiceFlowSteps }) => (
  <div className={styles.container} data-test-id="vertical-service-flow-section">
    <h2 className={styles.title}>{sectionTitle}</h2>
    <div className={styles.steps}>
      {verticalServiceFlowSteps.map((serviceFlowStep, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <article className={styles['steps-container']} key={`${index}-${serviceFlowStep.title}`}>
          <VerticalServiceFlowStep
            description={serviceFlowStep.description}
            imageUrl={serviceFlowStep.imageUrl}
            title={serviceFlowStep.title}
            stepNumber={index + 1}
          />
        </article>
      ))}
    </div>
  </div>
);

export type { Props as VerticalServiceFlowProps };
export default VerticalServiceFlow;
